import { buildPatch } from 'api/builders';

export const update = ({
  groupId, id, locationId, dispatch,
}) => buildPatch({
  url: `sign_up/api/menu/modifier_groups/${groupId}/modifiers/${id}?location_id=${locationId}`,
  dispatch,
});
